import { Map, OrderedMap } from 'immutable';
import React, { useState } from 'react';
import InstrumentFleetTable from './instrument-fleet-table/InstrumentFleetTable';
import { Toggle } from '../../frontend-common-libs/src/components/common/radio_button_group';
import { FleetToggleOptions, FleetToggleOptionsEnum } from './FleetManagementOptions';

export type Props = {
  instruments: OrderedMap<string, Map<string, any>>;
  projectId: string;
  statuses: Map<string, Map<string, any>>;
  fetchMoreData: (...args: Array<any>) => any;
  isLoading: boolean;
  isError: boolean;
};

export default function FleetManagement(props: Readonly<Props>) {
  const [toggleCheckedValue, setToggleCheckedValue] = useState<string>(
    FleetToggleOptionsEnum.Create
  );

  const onUpdateFleetToggle = (e: React.MouseEvent<HTMLButtonElement>) => {
    setToggleCheckedValue(e.currentTarget.value);
  };

  const updateFleetToggleCallback = (toggleValue: string) => {
    setToggleCheckedValue(toggleValue);
  };

  const { instruments, projectId, statuses, fetchMoreData, isLoading, isError } = props;
  return (
    <>
      <Toggle
        id="fleet-instrument-toggle-options"
        name="fleet-instrument-toggle"
        onChange={onUpdateFleetToggle}
        options={FleetToggleOptions}
        checkedValue={toggleCheckedValue}
      />
      <hr />
      <InstrumentFleetTable
        instruments={instruments}
        projectId={projectId}
        selectedFleetToggle={toggleCheckedValue}
        setFleetToggleCallback={updateFleetToggleCallback}
        statuses={statuses}
        fetchMoreData={fetchMoreData}
        isLoading={isLoading}
        isError={isError}
      />
    </>
  );
}
